'use es6';

import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { messageTextType, portalMigrationLearnMoreLink } from 'EmailData/constants/portalMigration';
import { jsx as _jsx } from "react/jsx-runtime";
export const getNumberofDaysBetweenDates = (fromDate, toDate) => {
  const formattedFromDate = I18n.moment.userTz(fromDate).startOf('day');
  const formattedToDate = toDate ? I18n.moment.userTz(toDate).startOf('day') : I18n.moment.userTz().startOf('day');
  return formattedFromDate.diff(formattedToDate, 'days');
};
export const getMigrationMessageProps = (portalMigrationHoistingHublet, portalMigrationStartDate, msgTextType = messageTextType.scheduleText, isSendNow = false) => {
  const messageHeading = isSendNow ? 'sendNowHeading' : 'heading';
  const messageProps = {
    headingText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `EmailComponents.seamlessPortalMigration.message.${messageHeading}`
    }),
    title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        KnowledgeBaseButton
      },
      message: `EmailComponents.seamlessPortalMigration.message.${msgTextType}_jsx`,
      options: {
        migrationHoistingHublet: I18n.text(`hublets.${portalMigrationHoistingHublet}`),
        migrationStartDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "medium-full-date",
          value: portalMigrationStartDate
        }),
        kbLink: portalMigrationLearnMoreLink
      }
    })
  };
  return messageProps;
};